import './styles.scss'
import React, { Fragment } from 'react'

import { FilterFields, IconBar } from './Filter'
import { lang } from 'utils/helpers'


const FIELDS = ['brands', 'delegations', 'channels']

/**
 * It's a function that returns a JSX element
 * @param props - the props passed to the component
 * @param {object} fieldsFilter - field to show
 * @param {array} searchFilter - fields name
 * @param {object} valueFilters - filters values
 * @param {function} handleOnChange
 * @param {string} statusIconFilter - on || off
 * @param {function} resetFilters
 * @param {object} brands
 * @param {object} delegations
 * @param {array} channels
 * @returns A component that is a scrollable content with a search bar and a list of filters.
 */
const SearchFilters = (props) => {
  const { fieldsFilter, searchFilter, valueFilters, handleOnChange, statusIconFilter, resetFilters, brands, delegations, onlyAssignedConversations } = props
 

  const options = ( field ) => Object.values(props[field]).map((b) => ({
    value: field === 'channels' ? b.channel : b._id,
    label: field === 'channels' ? lang(`channels_${b.channel}`) : b.name,
  }))

  return (
    <div className='search-filters'>
      <IconBar resetFilters={resetFilters} status={statusIconFilter} />
      <div className='search-filters__content'>
        <div className='sidemenu_search sidemenu_search_filter_booking new_sideMenu_filters'>
          <div className='sidemenu-search-text'>
            {
              searchFilter.map((field, idx) => {
                if(onlyAssignedConversations && field === 'assigned') return null
                
                if (FIELDS.includes(field) && !fieldsFilter[field].options) fieldsFilter[field].options = options(field)
                return (
                  <Fragment key={idx}>
                    <FilterFields
                      field={fieldsFilter[field]}
                      valueFilters={valueFilters}
                      handleOnChange={handleOnChange}
                      brands={Object.values(brands)}
                      delegations={Object.values(delegations)}
                    />
                    {fieldsFilter[field].divider && <div className='dividerFilter'></div>}
                  </Fragment>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchFilters
